import { Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';
// import {PasswordService} from '../../../common/services/Password.service';

declare var $: any;

@Component({
  selector: 'sd-forgot-password',
  templateUrl: './forgot-password.component.html',
  providers: [],
})
export class ForgotPasswordComponent implements OnInit {
  public phone: string;
  public code: string;
  public password: string;
  public cpassword: string;
  public error: string;
  public requestOtp = true;
  public icheckId: string;
  public model: any = {};
  public message: { class: string; content: string } = null;

  constructor(
    public httpClient: HttpClient,
    // public passService: PasswordService,
    public router: Router
  ) {
    const body = document.getElementsByTagName('body')[0];
    body.classList.add('animsition'); // add the class
    body.classList.add('page-login-v3'); // add the class
    body.classList.add('layout-full'); // add the class
  }

  ngOnInit() {
    $('#resetPassword').hide();
    $('#requestPassword').show();
  }

  // submitOTP(data) {
  //     this.passService.requestPassword(data).toPromise().then(res => {
  //             if (res) {
  //                 if (res.status == 200) {
  //                     this.message = {
  //                         class: "alert dark alert-success",
  //                         content: "Đã thực hiện gửi mã OTP tới số điện thoại của bạn."
  //                     };
  //                     if (res.data.icheck_id) {
  //                         this.icheckId = res.data.icheck_id;
  //                     }
  //                 } else {
  //                     this.message = {
  //                         class: "alert dark alert-danger",
  //                         content: res.status + ' : ' + res.message
  //                     };
  //                 }
  //                 $("#requestPassword").hide();
  //                 $("#resetPassword").show("slow");
  //             }
  //         },
  //         err => {
  //             this.message = {content: err.message, class: "alert dark alert-danger"};
  //         }
  //     );
  // }

  // resetPwd(data) {
  //     let mData = {
  //         code: data.code,
  //         icheck_id: this.icheckId,
  //         password: data.password,
  //         type: "otp"
  //     };
  //     this.passService.resetPassword(mData).toPromise().then(res => {
  //             if (res) {
  //                 if (res.status == 200) {
  //                     this.message = {
  //                         class: "alert dark alert-success",
  //                         content: "Tạo mới mật khẩu thành công."
  //                     };
  //                     $("#code").val('');
  //                     $("#password").val('');
  //                     $("#confirmPassword").val('');
  //                 } else {
  //                     if(res.message){
  //                         this.message = {
  //                             class: "alert dark alert-danger",
  //                             content: res.status + ' : ' + res.message
  //                         }
  //                     }else{
  //                         let mess = '';
  //                         for (let m of res.invalidAttributes.code){
  //                             mess += mess ? '. '+m.message : m.message;
  //                         }
  //                         this.message = {
  //                             class: "alert dark alert-danger",
  //                             content: mess
  //                         }
  //                     }
  //                 }
  //             }
  //         },
  //         err => {
  //             this.message = {content: err.message, class: "alert dark alert-danger"};
  //         }
  //     );
  // }
}



// WEBPACK FOOTER //
// ./src/app/pages/admin/auth/forgot-password.component.ts